export default __webpack_public_path__ + "static/media/download_icon.26f2e6d0.svg";